'use client';

import { useEffect } from 'react';

import { StaticPackProduct } from '@app-types/home-pack';
import { PRICE_TYPE } from '@app-types/price';
import { Product } from '@app-types/product';
import { SimulatedCart } from '@app-types/simulator/virtual-cart';

export function useAddStaticProduct(
    currentSimulatedCart: SimulatedCart,
    setCurrentSimulatedCart: (cart: SimulatedCart) => void,
    selectedStaticProduct: StaticPackProduct | null,
) {
    useEffect(() => {
        const updatedSimulatedCart = { ...currentSimulatedCart };
        if (selectedStaticProduct?.mainProduct && selectedStaticProduct.details && currentSimulatedCart) {
            const product: Partial<Product> = {
                gencode: `${selectedStaticProduct.mainProduct.id}`,
                name: selectedStaticProduct.details.pouces
                    ? `${selectedStaticProduct.mainProduct.name} ${selectedStaticProduct.details.pouces}"`
                    : selectedStaticProduct.mainProduct.name,
                details: {
                    price: {
                        initial: selectedStaticProduct.details.priceStriked,
                        final: selectedStaticProduct.details.price,
                        forever: 0,
                        type: PRICE_TYPE.TODAY,
                    },
                    fundings: [],
                    discounts: [],
                },
            };

            updatedSimulatedCart.quotes[0]?.products.splice(0, 1, product as Product);
        } else {
            updatedSimulatedCart.quotes[0]?.products.splice(0, 1);
        }
        setCurrentSimulatedCart(updatedSimulatedCart);
    }, [selectedStaticProduct]);
}
